'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Drop';

var EntypoDrop = function EntypoDrop(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10.203,0.561c-0.027-0.215-0.38-0.215-0.406,0C8.914,7.668,4.399,9.133,4.399,14.073c0,3.053,2.564,5.527,5.601,5.527c3.036,0,5.6-2.475,5.6-5.527C15.6,9.133,11.086,7.668,10.203,0.561z M9.35,8.418C9.291,8.637,9.227,8.862,9.161,9.096c-0.401,1.424-0.856,3.039-0.856,4.906c0,1.012-0.598,1.371-1.156,1.371c-0.639,0-1.156-0.523-1.156-1.166c0-2.207,1.062-3.649,2-4.92c0.295-0.398,0.572-0.775,0.797-1.15C8.893,7.965,9.17,7.973,9.296,8.143C9.355,8.223,9.375,8.325,9.35,8.418z' })
    );
};

exports.default = EntypoDrop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/Drop.js
// module id = 563
// module chunks = 168707334958949